import React from 'react';

const AboutSection = () => {
  return (
    <div className="about">
      <div className="about--banner">
        <h2>3<br />Years in<br />Websites<br />Developing</h2>
        <img src="assets/img/about-visual.png" alt="About Us" />
      </div>
    </div>
  );
};

export default AboutSection; 